// extracted by mini-css-extract-plugin
export default {"title":"prMwU","item":"ZkokZ","link":"Kq13n"};